<template>
  <div class="p-3 bg-morado-oscuro mb-4">
    <div id="summarypie">
      <span
        class="h5 text-white font-weight-bold px-0 text-center text-lg-left gilmer d-block"
        >Proyecto de Integración Escolar</span
      >
      <b-collapse id="texto-proyecto-integracion" class="mb-0 text-white">
        <!--<p
          id="proyecto-educativo"
          class="text-justify mb-0"
          v-for="(text, index) in textoComputado"
          :key="index + '-parrafo-proyecto'"
        >
          {{ text }}
        </p>-->
        <p id="proyecto-educativo" class="text-justify mb-0">
          {{ textoDefault }}
        </p>
      </b-collapse>
      <a
        v-b-toggle.texto-proyecto-integracion
        @click="
          $gtag.event('ver-resumen-proyecto-integracion', {
            event_category: 'proyecto-integracion',
            event_label: 'resumen-proyecto-integracion',
            value: ''
          })
        "
        id="boton-texto-proyecto-integracion"
        data-testid="boton-texto-proyecto-integracion"
        class="btn-secondary d-block mt-0 mb-2 btn btn-yellow font-weight-bold pointer"
      ></a>
    </div>
  </div>
</template>

<script>
import { library } from "@fortawesome/fontawesome-svg-core";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
library.add(faDownload);
export default {
  components: {
    FontAwesomeIcon
  },
  props: {
    textoProyecto: {
      type: String,
      required: true,
      default: ""
    },
    resumenProyectoPIE: {
      type: String,
      required: false,
      default: ""
    }
  },
  data() {
    return {
      urlCdn: CDN,
      prefijoDocumentos: URL_DOCUMENTOS
    };
  },
  computed: {
    textoComputado() {
      return this.textoProyecto.split("\n");
    },
    textoDefault() {
      const textoAlternativo =
        "El PIE es una estrategia inclusiva que contribuye al acceso, la participación y el progreso en los aprendizajes de todos los estudiantes, en especial de aquellos que requieren mayores apoyos (necesidades educativas especiales o NEE) ya sea durante un periodo de su trayectoria educativa o a lo largo de toda su escolaridad. Los apoyos que entrega el PIE pueden ser de diferentes profesionales especializados, recursos materiales educativos adicionales y todos aquellos que permitan a los estudiantes avanzar en su aprendizaje y culminar su proceso educativo.";

      return this.resumenProyectoPIE && this.resumenProyectoPIE.trim() !== ""
        ? this.resumenProyectoPIE
        : textoAlternativo;
    }
  },
  methods: {}
};
</script>



// WEBPACK FOOTER //
// src/components/ficha/izquierda/ProyectoIntegracion.vue